module.exports = __webpack_public_path__ + "static/media/GLORY_5831.8911915e.jpg";